export const CONTENT_TAB = 'formula'
export const STYLES_TAB = 'template'
export const DEFAULT_FINDER_TAB = "formula"
export const PROPERTIES_STYLES_TAB = 'mainHub-style'
export const PROPERTIES_TAB = 'mainHub'